import {
    Component,
    ChangeDetectionStrategy,
    Input,
    Type,
} from '@angular/core';
import { Result } from '@team23/ts-result';
import { isMobile } from '@ui/shared/ui-common';
import { ApiDataStatus } from '@ui/shared/util-api';
import { ListItem, ListItemComponent } from '@ui/shared/util-list';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    standalone: false,
})
export class ListComponent<ListItemType extends ListItem> {
    @Input({ required: true })
    public listItems!: Result<Array<ListItemType>, ApiDataStatus>;

    @Input()
    public areFiltersExpanded = false;

    @Input()
    public itemContentComponentType!: Type<ListItemComponent<ListItemType>>;

    public loadingStatus = ApiDataStatus.Loading;

    public get isMobile(): boolean {
        return isMobile();
    }
}
